import React from "react"
// import I18n from "i18n-js/index.js.erb"

export default class BookingSignIn extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      forgot_password_visible: false
    };

    this.onToggleForgotPassword = this.onToggleForgotPassword.bind(this);
  }

  render() {
    return (
      <div className="BookingSignIn">
        {
          this.state.forgot_password_visible
          ?
          this.renderForgotPassword()
          :
          this.renderSignIn()
        }
      </div>
    );
  }

  renderSignIn() {
    return (
      <form onSubmit={this.props.onSignIn}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('email_address')}</label>
              <input type="email" className="form-control" name="email" value={this.props.sign_in_information.email || ''} onChange={this.props.onChangeSignInInformation} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('password')}</label>
              <input type="password" className="form-control" name="password" value={this.props.sign_in_information.password || ''} onChange={this.props.onChangeSignInInformation} />
            </div>
          </div>
        </div>
        <div className="form-group">
          <button type="submit" className="btn">{I18n.t('sign_in')}</button>
        </div>
        <p>
          <a href='#' onClick={this.props.onToggleSignIn}>{I18n.t('back')}</a>
          <span style={{color: '#AFAFAF', marginLeft: 7, marginRight: 7}}>|</span>
          <a href='#' onClick={this.onToggleForgotPassword}>{I18n.t('forgot_password')}</a>
        </p>
      </form>
    );
  }

  renderForgotPassword() {
    return (
      <form onSubmit={this.props.onForgotPassword}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('email_address')}</label>
              <input type="email" className="form-control" name="email" value={this.props.sign_in_information.email || ''} onChange={this.props.onChangeSignInInformation} />
            </div>
          </div>
        </div>
        <div className="form-group">
          <button type="submit" className="btn">{I18n.t('forgot_password')}</button>
        </div>
        <p>
          <a href='#' onClick={this.onToggleForgotPassword}>{I18n.t('sign_in')}</a>
          <span style={{color: '#AFAFAF', marginLeft: 7, marginRight: 7}}>|</span>
          <a href='#' onClick={this.props.onToggleSignIn}>{I18n.t('continue_as_guest')}</a>
        </p>
      </form>
    );
  }



  /**
  * Change handlers
  */

  onToggleForgotPassword() {
    this.setState({forgot_password_visible: !this.state.forgot_password_visible});
  }

};
